// extracted by css-extract-rspack-plugin
export default {"submitContainer":"submitContainer-RgUrZ","formContainer":"formContainer-gqW5P"};